/** @internal */
// eslint-disable-next-line no-var, @typescript-eslint/naming-convention
export var __IGLTFExporterExtension = 0; // I am here to allow dts to be created
//# sourceMappingURL=glTFFileExporter.js.map